module.exports = __webpack_public_path__ + "img/pic1.37b7346a.png";